export default __webpack_public_path__ + "static/media/newsbanner.17b58e42.png";